import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axios";
import DOMPurify from "dompurify";

const InvestmentDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [investment, setInvestment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    axiosInstance
      .get(`/api/investments/${id}`)
      .then((res) => setInvestment(res.data))
      .catch(() => setInvestment(null))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <div className="animate-spin w-10 h-10 border-2 border-[#BA1500] border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!investment) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <p className="text-gray-600 mb-4">Investment not found.</p>
        <button
          onClick={() => navigate("/investments")}
          className="text-[#BA1500] font-semibold hover:underline"
        >
          Back to Investments
        </button>
      </div>
    );
  }

  const safeHtml = investment.description
    ? DOMPurify.sanitize(investment.description)
    : "";

  return (
    <div className="flex flex-col items-center mx-auto w-full px-4 sm:px-6 max-w-4xl py-8">
      <button
        onClick={() => navigate("/investments")}
        className="self-start text-[#BA1500] font-semibold hover:underline mb-6"
      >
        ← Back to Investments
      </button>
      <h1 className="text-2xl sm:text-3xl font-bold text-[#BA1500] mb-6 text-center">
        {investment.name}
      </h1>
      {safeHtml ? (
        <div
          className="prose prose-lg max-w-none w-full text-gray-800"
          dangerouslySetInnerHTML={{ __html: safeHtml }}
        />
      ) : (
        <p className="text-gray-600 text-center">No description yet.</p>
      )}
    </div>
  );
};

export default InvestmentDetail;
